import { fixContent } from "../../utils";
import { not_available_vertical } from "../../pngs";
import {
  CoalitionProgressBar,
  SingleProductImg,
} from "../CoalitionComplements";
import "./CoalitionCardAwards.scss";

export const CoalitionCardAwards = ({
  id,
  product,
  title,
  pointsRequired,
  points,
  showModal,
  buttonRef,
}) => {
  return (
    <div
      className="card-awards"
      ref={buttonRef}
      onClick={() => showModal(id)}
      onKeyPress={() => showModal(id)}
      role="button"
      tabIndex={0}
    >
      <div className="product">
        <SingleProductImg load={product} error={not_available_vertical} />
      </div>
      <div className="description">
        <div className="title">
          <span>{fixContent(title, 48)}</span>
        </div>
        <div className="progress">
          <CoalitionProgressBar current={points} max={pointsRequired} />
          <div className="progress-label">
            <div>{pointsRequired}</div>
            <div>Puntos</div>
          </div>
        </div>
      </div>
    </div>
  );
};
